<template>
  <div class="lottie-bg-canvas-player__container"></div>
</template>

<script>
import lottieWeb from "lottie-web";
import delayFunc from "@/utils/delay";
import { resolveResourceUrl } from "@/constants";

export default {
  methods: {
    async play(lottieId, options = { scale: 1, delay: 0, duration: 0 }) {
      // 여기서 크로마키를 설정하지 말자 여기서는 Transparent만 제공하면 된다.
      // 가장 바깥쪽 래퍼에서 제공하면 되는거임

      // lottieWeb.destroy();
      if (this.animation) this.animation.destroy();

      const { scale = 1, delay, duration } = options;

      this.$el.querySelectorAll(".lottie__wrapper").forEach((el) => {
        this.$el.removeChild(el);
      });

      // @duplicate
      // create child el
      const el = document.createElement("div");
      el.classList.add("lottie__wrapper");
      el.style.width = `${(100 * scale).toFixed()}%`;
      el.style.height = `${(100 * scale).toFixed()}%`;

      // Center
      el.style.position = "absolute";
      el.style.top = "50%";
      el.style.left = "50%";
      el.style.transform = "translate(-50%, -50%)";

      this.$el.appendChild(el);

      await delayFunc(delay);
      this.animation = lottieWeb.loadAnimation({
        container: el,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: resolveResourceUrl(lottieId, "lotties/background-canvas"),
      });

      // try {
      //   // TODO: 없어도 될듯.. model 종료와 함께 정지된다
      //   await delayFunc(15 * 1000); // 혹시몰라서 15초로 해둔다
      //   this.$el.removeChild(el);
      // } catch (error) {}
    },
    stop() {
      if (this.animation) this.animation.destroy();

      this.$el.querySelectorAll(".lottie__wrapper").forEach((el) => {
        this.$el.removeChild(el);
      });
    },
  },
  destroyed() {},
};
</script>

<style scoped>
.lottie-bg-canvas-player__container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
</style>
